import { scaleContinuousContentY } from './scaleContinuousContentY'

export interface ContinuousZoomAnchor {
  scrollTop: number
  scrollLeft: number
  clientWidth: number
  clientHeight: number
  oldZoom: number
  focalX: number
  focalY: number
}

export function createContinuousZoomAnchor(
  container: Pick<
    HTMLElement,
    'scrollTop' | 'scrollLeft' | 'clientWidth' | 'clientHeight'
  >,
  oldZoom: number,
  focal?: { x: number; y: number }
): ContinuousZoomAnchor {
  return {
    scrollTop: container.scrollTop,
    scrollLeft: container.scrollLeft,
    clientWidth: container.clientWidth,
    clientHeight: container.clientHeight,
    oldZoom,
    focalX: focal?.x ?? container.clientWidth / 2,
    focalY: focal?.y ?? container.clientHeight / 2,
  }
}

export function resolveContinuousZoomScroll(args: {
  anchor: ContinuousZoomAnchor
  newZoom: number
  scrollPadding: number
  totalPages: number
  pageGap: number
  getPageHeightAtNewZoom: (page: number) => number
}): { scrollTop: number; scrollLeft: number } {
  const { anchor, newZoom, scrollPadding, totalPages, pageGap } = args
  if (anchor.oldZoom === 0 || newZoom === 0) {
    return { scrollTop: anchor.scrollTop, scrollLeft: anchor.scrollLeft }
  }

  const ratio = newZoom / anchor.oldZoom
  const oldContentY = anchor.scrollTop + anchor.focalY - scrollPadding
  const newContentY = scaleContinuousContentY(
    oldContentY,
    ratio,
    totalPages,
    args.getPageHeightAtNewZoom,
    pageGap
  )
  const newFocalY = newContentY + scrollPadding
  const newFocalX =
    (anchor.scrollLeft + anchor.focalX - scrollPadding) * ratio + scrollPadding

  return {
    scrollTop: Math.max(0, newFocalY - anchor.focalY),
    scrollLeft: Math.max(0, newFocalX - anchor.focalX),
  }
}
